import React, { Component } from 'react';
import { UnmountClosed } from 'react-collapse';
import moment from 'moment-timezone';

import Icon from './../../components/Icon';
import { StickyContainer, StickyHead, StickyBody } from './../../components/Sticky';

import formatTime from './../../utils/formatTime';

const filesMaxLength = 5;

class OrderFileList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            isSubOpen: false
        };

        this.toggle = this.toggle.bind(this);
        this.toggleSub = this.toggleSub.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    toggleSub() {
        this.setState(state => Object.assign({}, state, {
            isSubOpen: !state.isSubOpen
        }));
    }

    renderFileRow(file, idx) {
        return (
            <a className="row" key={idx} href={file.location} target="_blank" rel="noopener noreferrer">
                <div className="col-1 order-file-name">{file.name}</div>
                <div className="col-1 order-file-date ta-right">{file.owner_role} on {formatTime(file.created_at, 'dt')}</div>
            </a>
        );
    }

    render() {
        const { icon, fileList, setStickyRef, onResize, title } = this.props;
        const { isOpen, isSubOpen } = this.state;
        if (!fileList || !fileList.length) {
            return null;
        }
        const sortedList = fileList.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
        return (
            <div className="order-tab-collapse">
                <div className="order-tab-collapse-head" onClick={this.toggle}>
                    <Icon className="svg-icon" iconName={icon} />
                    <span className="order-tab-head-name">{title} ({sortedList.length} {sortedList.length === 1 ? 'file' : 'files'})</span>
                    {isOpen
                        ? <span className="arrow-down active"></span>
                        : <span className="arrow-down"></span>
                    }
                </div>
                {sortedList.length <= filesMaxLength ?
                    <UnmountClosed isOpened={isOpen} className="order-tab-collapse-body order-file-list" onRender={onResize}>
                        <div className="order-tab-content">
                            {sortedList.map(this.renderFileRow)}
                        </div>
                    </UnmountClosed>
                    :
                    <StickyContainer isBottom ref={setStickyRef}>
                        <StickyBody>
                            <UnmountClosed isOpened={isOpen} className="order-tab-collapse-body order-file-list" onRender={onResize} hasNestedCollapse>
                                <div className="order-tab-content">
                                    {sortedList.slice(0, filesMaxLength).map(this.renderFileRow)}
                                    <UnmountClosed isOpened={isSubOpen} onRender={onResize}>
                                        {sortedList.slice(filesMaxLength).map(this.renderFileRow)}
                                    </UnmountClosed>
                                </div>
                            </UnmountClosed>
                        </StickyBody>
                        <StickyHead classNameFixed="order-tab-collapse-footer-fixed">
                            {isOpen &&
                                <div className="order-tab-collapse-footer" onClick={this.toggleSub}>
                                    {!isSubOpen
                                        ? <div className="btn btn-show-all">Show all {sortedList.length} files <i className="arrow-down-xs"></i></div>
                                        : <div className="btn btn-show-all active">Show less <i className="arrow-down-xs"></i></div>
                                    }
                                </div>
                            }
                        </StickyHead>
                    </StickyContainer>
                }
            </div>
        );
    }
}

export default OrderFileList;


// WEBPACK FOOTER //
// ./src/components/order/OrderFileList.js